<!--操作组件，非首屏展示需要，比如操作弹窗等等-->
<script lang="ts" setup>
import { defineAsyncComponent } from '#imports'

const { isSingleFileMode = false } = defineProps<{
  isSingleFileMode?: boolean
}>()

const AsyncFileExplorerOperationBox = defineAsyncComponent(
  () => import('@/components/share/FileExplorerOperationBox.vue'),
)
</script>

<template>
  <AsyncFileExplorerOperationBox :is-single-file-mode="isSingleFileMode" />
</template>

<style lang="less"></style>
